// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1RShx","colBig":"styles_colBig__3SIQT","colSmall":"styles_colSmall__1EqI7"};